import router from '@/router'
var goBack = function (e) {
  if (e === 'PERSONAL') {
    router.push('/personal')
  } else {
    router.go(-1)
  }
}
export default goBack



// WEBPACK FOOTER //
// ./src/utils/goBack.js